<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" placeholder="搜索名称"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="状态">
              <a-select v-model="queryParam.status" placeholder="请选择"
                        allowClear >
                <a-select-option value="1">上架中</a-select-option>
                <a-select-option value="2">已下架</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd" >新建</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="setAllStatus(1)" key="1"><a-icon type="upload" />上架</a-menu-item>
          <a-menu-item @click="setAllStatus(2)" key="2"><a-icon type="download" />下架</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <s-table
            ref="table"
            size="default"
            :columns="columns"
            :data="loadData"
            :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
            :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="title1" slot-scope="text,record">
        <div style="margin-bottom: 10px;">{{record.title}}</div>
        <div>
          <img style="width: 68px ; height: 68px; float: left" :src="record.pic_url" />
          <div style="color: #999;margin-left: 10px; float: left">
             {{record.desc}}
            <br/>
            <a-badge status="success" v-if="record.status==1" text="上架中" />
            <a-badge status="default" v-else text="已下架" />
            <br/>
            打卡：{{record.daka_count}}
          </div>
        </div>
      </span>
      <span slot="price" slot-scope="text,record">
        <template >
        <div v-if="record.need_pay==1">
          <a-tag color="green">免费</a-tag>
        </div>
        <div v-else >
          ¥{{record.price}} <a-divider type="vertical" /> <a-tag color="blue">{{record.pay_days}}天有效</a-tag>
        </div>
          </template>
      </span>
      <span slot="orderCount" slot-scope="text,record">
        <template >
        <div>
          0
        </div>
        </template>
      </span>
      <span slot="rank" slot-scope="text,record">
        <template >
        <editable-cell :text="text" @change="onRankChange(record.id, 'rank', $event)"/>
        </template>
      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a @click="handleItemManage(record)">章节管理</a></br>
          <a @click="handleOrderManage(record)">订单</a>
          <a-divider type="vertical" />
          <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="deleteHandle(record)"  okText="确定" cancelText="取消">
            <a href="javascript:;">删除</a>
          </a-popconfirm>
        </template>
      </span>
    </s-table>
    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="visible"
            @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">


          <a-form-item
                  label="所属分类"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-tree-select
                    v-decorator="[
                  'cate_ids',
                  {rules: [{ required: true, message: '请输入选择分类' }]}
                ]"
                    style=" width: 90% ; margin-right: 10px; "
                    :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                    :treeData="cateOptions"
                    multiple
                    allowClear
                    treeNodeFilterProp="title"
                    placeholder='请选择分类'
                    treeDefaultExpandAll
                    v-model="formData.cate_ids"
            >
            </a-tree-select>
            <a-popover content="请选择分类,支持多选">
              <a-icon type="question-circle" />
            </a-popover>
          </a-form-item>

          <a-form-item
                  label="标题"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-input
                    style=" width: 90% ; margin-right: 10px; "
                    v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入课程标题' }]}
        ]"
                    placeholder="请输入课程标题"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="描述"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'desc',
          {rules: []}
        ]"
                        placeholder="请输入描述"/>
          </a-form-item>

          <a-form-item
                  label="视频等级"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-input
                    style=" width: 90% ; margin-right: 10px; "
                     v-decorator="[
          'level',
          {rules: []}
        ]"
                    placeholder="初级/中级/高级"/>
          </a-form-item>


          <a-form-item
                  label="列表小图"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="显示在列表页,推荐尺寸750x525,推荐格式jpg"
          >
            <pic-uploader
                    :file-list="formData.pic"
            />
          </a-form-item>

          <a-form-item
                  label="内页大图"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="显示详情页,推荐宽度750x525,推荐格式jpg"
          >
            <pic-uploader
                    :file-list="formData.pics"
            />
          </a-form-item>
          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="广告位展示"
                  hasFeedback
          >
            <r-switch  :formData="formData" field="recommend_status" :checkedValue="2" :unCheckedValue="1"  checkedChildren="是" unCheckedChildren="否" />
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否付费"
                  hasFeedback
          >
            <a-radio-group v-model="formData.need_pay" buttonStyle="solid">
              <a-radio-button :value="1">免费</a-radio-button>
              <a-radio-button :value="2">付费</a-radio-button>
            </a-radio-group>
          </a-form-item>
          <a-form-item
                  v-if="formData.need_pay==2"
                  label="金额"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-input
                    style=" width: 90% ; margin-right: 10px; "
                    v-decorator="[
          'price',
          {rules: [{ required: true, message: '请输入费用金额' }]}
        ]"
                    placeholder="请输入费用金额"/>
          </a-form-item>


          <a-form-item
                  v-if="formData.need_pay==2"
                  label="购买后有效期"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="用户购买开通活多少天内可用免费观看此课程"
          >
            <a-input
                    style=" width: 90% ; margin-right: 10px; "
                    v-decorator="[
          'pay_days',
          {rules: [{ required: true, message: '请输入天数' }]}
        ]"
                    placeholder="请输入天数"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="状态"
                  hasFeedback
          >
            <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="上架" unCheckedChildren="下架" />
          </a-form-item>


          <a-form-item
                  label="内容详情"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >

            <UEditor  style="width: 400px; height:520px;" :ueditorContent.sync="formData.content" ></UEditor>
          </a-form-item>


        </a-form>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="章节管理"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="itemVisible"
            @ok="itemVisible=false"
     >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table :columns="itemColumns" :dataSource="courseItemList" :pagination="itemPagination"
                   @change="handleItemTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="itemQuery.keywords"
                      placeholder="搜索"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="itemSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="itemSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>

            <span slot="rank" slot-scope="text,record">
              <template >
              <editable-cell :text="text" @change="onItemRankChange(record.id, 'rank', $event)"/>
              </template>
            </span>
            <span slot="status" slot-scope="text,record">
            <a-badge status="processing" v-if="record.status==1" text="上架中" />
            <a-badge status="default" v-else-if="record.status==2" text="已下架" />
            </span>
            <span slot="action" slot-scope="text,record">
              <template >
                <a @click="handleItemEdit(record)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm title="删除后不可恢复,确定删除吗?" @confirm="itemDeleteHandle(record)"  okText="确定" cancelText="取消">
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </template>
            </span>
            <template slot="footer" slot-scope="currentPageData">
              <a-button icon="plus" @click="handleItemAdd" >新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="操作"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="itemFormVisible"
            @ok="handleItemOk"
      >
      <a-spin :spinning="saveLoading">
        <a-form :form="itemForm" id="itemForm">
          <a-form-item
                  label="标题"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
          >
            <a-input
                    style=" width: 90% ; margin-right: 10px; "
                    v-decorator="[
          'title',
          {rules: [{ required: true, message: '请输入章节标题' }]}
        ]"
                    placeholder="请输入章节标题"/>
          </a-form-item>

          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="描述"
                  hasFeedback
          >
            <a-textarea autosize v-decorator="[
          'desc',
          {rules: []}
        ]"
                        placeholder="请输入描述"/>
          </a-form-item>


          <a-form-item
                  label="视频"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  extra="请上传视频文件"
          >
            <file-uploader
                    :number-limit="1"
                    accept=".mp4,.png"
                    :file-list="itemFormData.video"
            />
          </a-form-item>


          <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="状态"
                  hasFeedback
          >
            <r-switch  :formData="itemFormData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="上架" unCheckedChildren="下架" />
          </a-form-item>



        </a-form>


      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="itemFormVisible=false">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleItemOk">保存</a-button>
      </template>
    </a-modal>

    <a-modal
        :maskClosable="false"
            title="订单记录"
            :width="1000"
            style="top: 20px;"
            :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
            v-model="orderFormVisible"
            @ok="orderFormVisible=false"
      >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <div class="order-course">
            <a-table :columns="orderColumns" :dataSource="courseOrderList" :pagination="orderPagination"
                   @change="handleOrderTableChange"
                   rowKey="id" :scroll="{ y: 300 }" bordered>
            <div slot="filterDropdown" slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }" class='custom-filter-dropdown'>
              <a-input
                      v-model="orderQuery.keywords"
                      placeholder="搜索"
                      style="width: 188px; margin-bottom: 8px; display: block;"
              />
              <a-button
                      type='primary'
                      @click="orderSearch(selectedKeys, confirm)"
                      icon="search"
                      size="small"
                      style="width: 90px; margin-right: 8px"
              >搜索</a-button>
              <a-button
                      @click="orderSearchReset(selectedKeys, confirm)"
                      size="small"
                      style="width: 90px"
              >重置</a-button>
            </div>
            <span slot="status" slot-scope="text,record">
            <a-badge status="processing" v-if="record.status==2" text="已支付" />
            <a-badge status="default" v-else-if="record.status==1" text="未支付" />
            </span>

          </a-table>
          </div>
        </a-form>
      </a-spin>
    </a-modal>

  </a-card>
</template>

<script>
  import STable from '@/components/table/'
  import ATextarea from 'ant-design-vue/es/input/TextArea'
  import AInput from 'ant-design-vue/es/input/Input'
  import EditableCell from '@/components/EditableCell/'
  import RSwitch from '@/components/RSwitch/'
  import PicUploader from '@/components/PicUploader/'
  import PriceInput from '@/components/PriceInput/'
  import moment from 'moment'
  import UEditor from '@/components/UEditor/'
  import FileUploader from '@/components/FileUploader/'
  import {  getCourseList,getCateTreeList, deleteCourse,setCourseRank,setItemRank,editCourse,addCourse,getCourseDetail,getCourseItemList,addItem,editItem,deleteItem,getItemDetail,getCourseOrderList } from '@/api/course';
  export default {
    name: 'CourseList',
    components: {
      AInput,
      ATextarea,
      STable,
      EditableCell,
      RSwitch,
      PriceInput,
      PicUploader,
      UEditor,
      FileUploader
    },
    data () {
      return {
        visible: false,
        saveLoading:false,
        itemVisible:false,
        itemFormVisible:false,
        orderFormVisible:false,
        formData:{
          cate_ids:[],
          title: '',
          pic: [],
          pics: [],
          desc:'',
          content:'',
          price:0,
          need_pay:1,
          pay_days:365,
          status: 1,
          recommend_status:1,
          level:''
        },
        itemFormData:{
          course_id:0,
          title: '',
          desc:'',
          video:[],
          status: 1
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12 },
        },
        form: this.$form.createForm(this),
        itemForm: this.$form.createForm(this,{
          name:'itemForm'
        }),
        mdl: {},

        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {
          keywords:'',
        },
        cateOptions:[],
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '50px'
          },
          {
            title: '标题',
            dataIndex: 'title',
            scopedSlots: { customRender: 'title1' },
          },
          {
            width:'250px',
            title: '费用信息',
            dataIndex: 'price',
            scopedSlots: { customRender: 'price' },
          },
          {
            title: '排序',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '销量信息',
            width:'150px',
            dataIndex: 'order_count',
            scopedSlots: { customRender: 'orderCount' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          console.log('loadData');
          console.log(this.queryParam);
          this.queryParam = Object.assign(this.queryParam, parameter);
          return getCourseList(this.queryParam)
                  .then(res => {
                    console.log('res');
                    return res.data
                  })
        },

        selectedRowKeys: [],
        selectedRows: [],
        goodsOptions:[],
        youhuiquanOptions:[],
        //领取表头
        itemColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '标题',
            dataIndex: 'title',
            width:'230px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '播放次数',
            width:'100px',
            dataIndex: 'views_count'
          },
          {
            title: '打卡次数',
            width:'100px',
            dataIndex: 'daka_count'
          },
          {
            title: '排序',
            width:'100px',
            dataIndex: 'rank',
            scopedSlots: { customRender: 'rank' },
          },
          {
            title: '状态',
            width:'100px',
            dataIndex: 'status',
            scopedSlots: {
              customRender: 'status',
            },
            filters: [
              {
                text: '上架中',
                value: '1'
              },
              {
                text: '已下架',
                value: '2'
              }],
            filterMultiple:false,
          },
          {
            title: '操作',
            dataIndex: 'action',
            width: '180px',
            scopedSlots: { customRender: 'action' },
          },
        ],
        orderColumns: [
          {
            title: '#',
            dataIndex: 'id',
            width: '100px'
          },
          {
            title: '购买人',
            dataIndex: 'name',
            width:'100px',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'name',
            }
          },
          {
            title: '手机',
            width:'100px',
            dataIndex: 'phone',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'phone',
            }
          },
          {
            title: '金额',
            width:'80px',
            dataIndex: 'pay_price'
          },
          {
            title: '下单时间',
            width:'100px',
            dataIndex: 'order_time'
          },
          {
            title: '状态',
            width:'100px',
            dataIndex: 'status',
            scopedSlots: {
              customRender: 'status',
            },
            filters: [
              {
                text: '未支付',
                value: '1'
              },
              {
                text: '已支付',
                value: '2'
              }],
            filterMultiple:false,
          },
          {
            title: '截止日期',
            width:'100px',
            dataIndex: 'end_time',
          },

        ],
        itemPagination:{
        },
        itemQuery:{
          course_id:0,
          status:0,
          page:1,
          keywords:undefined
        },
        courseItemList:[],
        courseOrderList:[],
        orderPagination:{
        },
        orderQuery:{
          course_id:0,
          status:0,
          page:1,
          keywords:undefined,
        },

      }
    },
    computed: {
    },
    created(){
      let that = this;
      getCateTreeList()
              .then(res => {
                that.cateOptions =  res.data;
              })
    },
    mounted(){
      let that = this;
    },
    methods: {
      moment,
      handleCancel(){
        this.visible = false
      },
      // 增
      handleAdd() {
        console.log('moment.locale()')
        console.log(moment.locale());
        let that = this;
        this.visible = true;
        this.form.resetFields();
        this.formData = {
          id:0,
          cate_ids:[],
          title: '',
          pic: [],
          pics: [],
          desc:'',
          content:'',
          price:0,
          need_pay:1,
          pay_days:365,
          status: 1,
          recommend_status:1,
          level:''
        };
        setTimeout( () =>{
          that.form.setFieldsValue({ ...this.formData });
        },10);
      },
      // 改
      handleEdit(record) {
        let self = this
        getCourseDetail({ id: record.id }).then(res => {
          setTimeout(()=>{
            self.form.setFieldsValue({ ...res.data })
          },20)
//          self.formData = {...res.data};
          self.formData = Object.assign(self.formData, res.data) //尼玛 日期选择器有bug 必须这样赋值
          self.formData.id = res.data.id;
        })
        this.visible = true
      },

      // 增改 处理
      handleOk(e) {
        let self = this;
        e.preventDefault()
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.formData)
            self.saveLoading = true;
            if(self.formData.id) {
              editCourse(Object.assign(self.formData,values)).then(res => {
                self.$message.success('修改成功')
                self.$refs.table.refresh(false)
                self.visible = false;
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addCourse(Object.assign(self.formData,values)).then(res => {
                self.$message.success('新增成功')
                self.$refs.table.refresh(false)
                self.visible = false
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },
      // 查
      onSearch() {
        let self = this;
        self.$refs.table.refresh(false)
      },
      // 删
      deleteHandle(record) {
        let self = this
        deleteCourse({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.$refs.table.refresh(false)
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      onSelectChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
      },
      handleOrderManage(record){
        let self = this
        self.orderQuery.course_id = record.id;
        self.orderQuery.keywords = undefined;
        self.orderQuery.status = undefined;

        self.orderPagination.page = 1;
        self.fetchOrderList();
        this.orderFormVisible = true
      },
      fetchOrderList(){
        let self = this
        console.log(self.orderQuery,self.orderPagination)
        getCourseOrderList(Object.assign(self.orderQuery,self.orderPagination)).then(res => {
          self.courseOrderList = res.data.list
          self.orderPagination.total = res.data.total
        })
      },


      handleItemManage(record) {
        let self = this
        self.itemQuery.course_id = record.id;
        self.itemQuery.keywords = undefined;
        self.itemQuery.status = undefined;
        self.itemPagination.page = 1;
        self.fetchItemList();
        this.itemVisible = true
      },

      fetchItemList(){
        let self = this
        getCourseItemList(Object.assign(self.itemQuery,self.itemPagination)).then(res => {
          self.courseItemList = res.data.list
          self.itemPagination.total = res.data.total
        })
      },

      itemSearch(selectedKeys,confirm){
        let self = this
        confirm();
        self.fetchItemList();
      },
      itemSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.itemQuery.keywords = undefined;
        self.fetchItemList();
      },

      orderSearch(selectedKeys,confirm){
        let self = this
        confirm();
        console.log(self.orderQuery)
        self.fetchOrderList();
      },
      orderSearchReset(selectedKeys,confirm){
        let self = this;
        confirm();
        self.orderQuery.keywords = undefined;
        self.fetchOrderList();
      },
      handleItemTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.status){
          that.itemQuery.status = filters.status[0];
        }else{
          that.itemQuery.status = 0;
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.itemQuery.page = pagination.current;
        that.fetchItemList();
      },
      handleOrderTableChange(pagination, filters, sorter) {
        console.log('filters',filters);
        let that = this;
        if(filters.status){
          that.orderQuery.status = filters.status[0];
        }else{
          that.orderQuery.status = 0;
        }
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        that.pagination = pager;
        that.orderQuery.page = pagination.current;
        that.fetchOrderList();
      },


      // 增
      handleItemAdd() {
        let that = this;
        this.itemFormVisible = true;
        this.itemForm.resetFields();
        this.itemFormData = {
          id:0,
          course_id:this.itemQuery.course_id,
          title: '',
          desc:'',
          video:[],
          status: 1
        };
        setTimeout( () =>{
          that.itemForm.setFieldsValue({ ...this.itemFormData });
        },10);
      },
      // 改
      handleItemEdit(record) {
        let self = this
        getItemDetail({ id: record.id }).then(res => {
          setTimeout(()=>{
            self.itemForm.setFieldsValue({ ...res.data })
          },20)
//          self.formData = {...res.data};
          self.itemFormData = Object.assign(self.itemFormData, res.data) //尼玛 日期选择器有bug 必须这样赋值
          self.itemFormData.id = res.data.id;
        })
        this.itemFormVisible = true
      },

      // 删
      itemDeleteHandle(record) {
        let self = this
        deleteItem({ id: record.id }).then(res => {
          self.$message.success('删除成功')
          self.fetchItemList();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },
      // 增改 处理
      handleItemOk(e) {
        let self = this;
        e.preventDefault()
        this.itemForm.validateFields((err, values) => {
          if (!err) {
            console.log('Received values of form: ', values)
            console.log('Received valuess of formData: ', self.itemFormData)
            self.saveLoading = true;
            if(self.itemFormData.id) {
              editItem(Object.assign(self.itemFormData,values)).then(res => {
                self.$message.success('修改成功')
                self.itemFormVisible = false;
                self.fetchItemList();
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }else{
              addItem(Object.assign(self.itemFormData,values)).then(res => {
                self.$message.success('新增成功')
                self.fetchItemList();
                self.itemFormVisible = false
                self.saveLoading = false;
              }).catch(err =>{
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              })
            }
          }
        })
      },

      onRankChange(key, dataIndex, value) {
        let self = this;
        setCourseRank({
          id: key,
          rank:value
        }).then(res => {
          self.fetch();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

      onItemRankChange(key, dataIndex, value) {
        let self = this;
        setItemRank({
          id: key,
          rank:value
        }).then(res => {
          self.fetch();
        }).catch(err =>{
          self.$message.error(err.data.msg)
        })
      },

    },
    watch: {
      /*
       'selectedRows': function (selectedRows) {
       this.needTotalList = this.needTotalList.map(item => {
       return {
       ...item,
       total: selectedRows.reduce( (sum, val) => {
       return sum + val[item.dataIndex]
       }, 0)
       }
       })
       }
       */
    }
  }
</script>


<style scoped>

.order-course >>> .ant-table-thead > tr > th,.order-course >>> .ant-table-tbody > tr > td{
  padding: 16px 0 !important;
  text-align: center;
}
  .custom-filter-dropdown {
    padding: 8px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  }

  .highlight {
    background-color: rgb(255, 192, 105);
    padding: 0px;
  }
</style>
